module.exports = __webpack_public_path__ + "img/espaco3.12df4222.jpg";